import { orFallback } from 'modules/utils/StringUtils';
import { ReferenceSystem } from 'store/testResults/types';

export const orNA = (string?: string | null) => orFallback(string, 'N/A');
export const getLabValue = (ref: ReferenceSystem | null | undefined, valueString: string | null) =>
  orNA((ref && `${ref.value} ${ref.unit || ''}`) || valueString);
